/**
 * [mojdzial1006, paczka MD-KIT → właściciel MD-CZAS, projekt §2.2, §2.8 S9, §3.4–3.7] REJESTR — GRUPA „CZAS PRACY”.
 *
 * Grafik, Urlopy i Praca zdalna to wzór S9 „Kalendarz zespołu” (`KalendarzZespolu`): żetony = SKALE tego samego kalendarza
 * (`widoki[].skala`, Z-04 doprecyzowane), okres w głowie listy jako dwa ciche ‹ › (D-18). Aktywność to lista S2 z żetonami
 * OKRESU (`parametrZetonow: "okres"`, D-18) i pełny ekran osoby pod trasą obiektu `dzialAktywnoscOsoba` (rysowany poza
 * powłoką; nowy plik `pages/mojDzial/obiekty/AktywnoscOsoby.js` — żywy `MyDeptWorkTimeUserPage` zamrożony do MD-WLACZ).
 * `glowa.okres` to NAJDŁUŻSZY napis okresu — wyłącznie do szacunku szerokości głowy (N-2, MD-17).
 */
import { GRUPY_MOJEGO_DZIALU, kreatoryMiejsca, miejsceZZakladki, obiektyMiejsca } from "./wspolne";

const OKRES_TYGODNIA = "29 września – 5 października 2026";
const OKRES_MIESIACA = "październik 2026";

export const miejsceGrafik = miejsceZZakladki("grafik", {
    grupa: GRUPY_MOJEGO_DZIALU.czas,
    etykieta: "Grafik",
    zdanie: "Gdzie i w jakich godzinach pracują Twoi ludzie, dzień po dniu.",
    wzor: "S9",
    widoki: [
        { id: "tydzien", etykieta: "Tydzień", skala: true },
        { id: "miesiac", etykieta: "Miesiąc", skala: true },
    ],
    filtry: ["kto", "miejsce", "jednostka", "tylko", "tydzien", "miesiac"],
    obiekty: obiektyMiejsca("dzien"),
    // „udziel-urlopu” otwiera też Grafik (Więcej ▾, szuflada dnia), ale nazwa kreatora jest jednoznaczna na stronie (N-18) —
    // stoi raz, w Urlopach; `otworzKreator` działa z każdego miejsca modułu.
    kreatory: kreatoryMiejsca("uloz-grafik", "zatwierdz-tydzien", "opublikuj-szkice"),
    pasek: {
        akcjaGlowna: "Ułóż grafik…",
        wiecej: ["Opublikuj szkice…", "Zatwierdź tydzień…", "Cofnij zatwierdzenie tygodnia…", "Udziel urlopu…", "Drukuj grafik…", "Pobierz CSV…", "Rozwiń wszystkie grupy"],
    },
    glowa: { zdanieStanu: "12 osób · 412 h · szkic u 3", okres: OKRES_TYGODNIA },
    sekcje: [{ id: "pominiete", etykieta: "Pominięte przy ostatnim zapisie" }],
    zdarzeniaNaZywo: ["calendar-changed", "hr-notification"],
    slowa: ["grafik", "godziny pracy", "szkic grafiku", "zatwierdź tydzień", "plan dnia", "dyspozycja", "drukuj grafik"],
    komponent: () => import("../../../pages/mojDzial/miejsca/Grafik"),
});

export const miejsceUrlopy = miejsceZZakladki("urlopy", {
    grupa: GRUPY_MOJEGO_DZIALU.czas,
    etykieta: "Urlopy",
    zdanie: "Kto kiedy ma urlop, ile mu zostało i co czeka na Twoją decyzję.",
    wzor: "S9",
    licznik: true,
    widoki: [
        { id: "miesiac", etykieta: "Miesiąc", skala: true },
        { id: "rok", etykieta: "Rok", skala: true },
    ],
    filtry: ["kto", "jednostka", "zakresDni", "byli", "miesiac", "rok"],
    obiekty: obiektyMiejsca("zakres", "wniosek"),
    kreatory: kreatoryMiejsca("udziel-urlopu"),
    pasek: { akcjaGlowna: "Udziel urlopu…", wiecej: ["Pobierz CSV…"] },
    glowa: { zdanieStanu: "Zatwierdzono 312 dni · średnio 14 na osobę · niska obsada: lipiec", okres: OKRES_MIESIACA },
    sekcje: [
        { id: "zalegle", etykieta: "Zaległe urlopy do udzielenia" },
        { id: "zakresy", etykieta: "Zatwierdzone urlopy zespołu" },
    ],
    zdarzeniaNaZywo: ["hr-notification", "hr-request-changed", "calendar-changed"],
    slowa: ["urlopy", "plan urlopów", "saldo urlopu", "zaległy urlop", "kalendarz urlopów", "wykres roczny", "obsada"],
    komponent: () => import("../../../pages/mojDzial/miejsca/Urlopy"),
});

export const miejscePracaZdalna = miejsceZZakladki("praca-zdalna", {
    grupa: GRUPY_MOJEGO_DZIALU.czas,
    etykieta: "Praca zdalna",
    zdanie: "Dni zdalne Twoich ludzi, ich raporty i limity — i co czeka na decyzję.",
    wzor: "S9",
    licznik: true,
    widoki: [
        { id: "miesiac", etykieta: "Miesiąc", skala: true },
        { id: "rok", etykieta: "Rok", skala: true },
    ],
    filtry: ["kto", "jednostka", "stan", "miesiac", "rok"],
    obiekty: obiektyMiejsca("raport", "wniosek"),
    pasek: { wiecej: ["Pobierz CSV…"] },
    glowa: { zdanieStanu: "12 osób · dni zdalnych w październiku: 18 · bez raportu: 2", okres: OKRES_MIESIACA },
    zdarzeniaNaZywo: ["hr-notification", "hr-request-changed"],
    dziennikWejscia: "MyDeptRemotePage",
    slowa: ["praca zdalna", "raporty dnia", "dzień zdalny", "limit dni zdalnych", "protokoły pracy zdalnej"],
    komponent: () => import("../../../pages/mojDzial/miejsca/PracaZdalna"),
});

export const miejsceAktywnosc = miejsceZZakladki("czas-pracy", {
    grupa: GRUPY_MOJEGO_DZIALU.czas,
    etykieta: "Aktywność",
    zdanie: "Ile i kiedy zespół pracował w Office 365 i mPracowniku — bez treści i adresów.",
    wzor: "S2",
    // Żetony OKRESU (D-18): `?okres=dzis|7|30|inny` — te same nazwy co panel analityki; „Inny okres” rozwija Od / Do w filtrach.
    parametrZetonow: "okres",
    widoki: [
        { id: "dzis", etykieta: "Dziś" },
        { id: "7", etykieta: "7 dni" },
        { id: "30", etykieta: "30 dni" },
        { id: "inny", etykieta: "Inny okres" },
    ],
    filtry: ["okres", "od", "do", "jednostka"],
    obiekty: obiektyMiejsca(),
    pasek: { szukajka: "Szukaj osoby…", wiecej: ["Czego nie widzimy"] },
    glowa: { zdanieStanu: "Dane z 4 z 5 kont · stan z 06:00" },
    sekcje: [
        { id: "wykresy-o365", etykieta: "Office 365 — wykresy zespołu" },
        { id: "wykresy-mpracownik", etykieta: "mPracownik — wykresy zespołu" },
    ],
    slowa: ["aktywność O365", "czas pracy", "logowania", "Teams", "Office 365", "mPracownik"],
    komponent: () => import("../../../pages/mojDzial/miejsca/Aktywnosc"),
});

/**
 * Pełny ekran aktywności osoby — trasa obiektu (identyfikator w ścieżce), rysowana POZA powłoką; rejestr zna ją tylko do budowy
 * adresów (`adresObiektu("dzialAktywnoscOsoba", { id })`) i lustra tras.
 */
export const TRASA_AKTYWNOSCI_OSOBY = {
    kluczTrasy: "dzialAktywnoscOsoba",
    segment: { pl: "czas-pracy/osoba/:id", en: "worktime/user/:id" },
    obszar: "czas-pracy",
    parametr: "id",
    rodzaj: "pelny-ekran",
    nazwa: "aktywność osoby",
    dopelniacz: "aktywności osoby",
    paczka: "MD-CZAS",
    plik: "obiekty/AktywnoscOsoby",
};

export const miejscaCzasu = [miejsceGrafik, miejsceUrlopy, miejscePracaZdalna, miejsceAktywnosc];

export default miejscaCzasu;
